import { getCustomQueries } from '@/helpers/queryHelper';
import {
  GET_ALL_ASSESSMENT_FAILED,
  GET_ALL_ASSESSMENT_REQUEST,
  GET_ALL_ASSESSMENT_SUCCEEDED,
} from './index';

export const getAllAssessmentQuestion = (data, user) => {
  let query = getCustomQueries(data);

  return {
    type: GET_ALL_ASSESSMENT_REQUEST,
    payload: {
      url:
        user === 'staff' || user === 'admin' || user === 'instructor'
          ? `all-assessment-question/?${query}`
          : `client-assessment-answer/?${query}`,
      onSuccess: GET_ALL_ASSESSMENT_SUCCEEDED,
      onFailure: GET_ALL_ASSESSMENT_FAILED,
    },
  };
};
